// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file ga/config_manager/casinokey/casinokey.proto (package ga.config_manager.casinokey, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ga/config_manager/casinokey/casinokey.proto.
 */
export const file_ga_config_manager_casinokey_casinokey: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message ga.config_manager.casinokey.GenerateRequest
 */
export type GenerateRequest = Message<"ga.config_manager.casinokey.GenerateRequest"> & {
  /**
   * @generated from field: string casino_id = 1;
   */
  casinoId: string;
};

/**
 * Describes the message ga.config_manager.casinokey.GenerateRequest.
 * Use `create(GenerateRequestSchema)` to create a new message.
 */
export const GenerateRequestSchema: GenMessage<GenerateRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 0);

/**
 * @generated from message ga.config_manager.casinokey.GenerateResponse
 */
export type GenerateResponse = Message<"ga.config_manager.casinokey.GenerateResponse"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;
};

/**
 * Describes the message ga.config_manager.casinokey.GenerateResponse.
 * Use `create(GenerateResponseSchema)` to create a new message.
 */
export const GenerateResponseSchema: GenMessage<GenerateResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 1);

/**
 * @generated from message ga.config_manager.casinokey.RolloutRequest
 */
export type RolloutRequest = Message<"ga.config_manager.casinokey.RolloutRequest"> & {
  /**
   * @generated from field: string casino_id = 1;
   */
  casinoId: string;
};

/**
 * Describes the message ga.config_manager.casinokey.RolloutRequest.
 * Use `create(RolloutRequestSchema)` to create a new message.
 */
export const RolloutRequestSchema: GenMessage<RolloutRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 2);

/**
 * @generated from message ga.config_manager.casinokey.RolloutResponse
 */
export type RolloutResponse = Message<"ga.config_manager.casinokey.RolloutResponse"> & {
};

/**
 * Describes the message ga.config_manager.casinokey.RolloutResponse.
 * Use `create(RolloutResponseSchema)` to create a new message.
 */
export const RolloutResponseSchema: GenMessage<RolloutResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 3);

/**
 * @generated from message ga.config_manager.casinokey.CasinoKeyInfo
 */
export type CasinoKeyInfo = Message<"ga.config_manager.casinokey.CasinoKeyInfo"> & {
  /**
   * @generated from field: string casino_id = 1;
   */
  casinoId: string;

  /**
   * @generated from field: string key_obfuscated = 2;
   */
  keyObfuscated: string;

  /**
   * @generated from field: ga.config_manager.casinokey.CasinoKeyState state = 3;
   */
  state: CasinoKeyState;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string last_action_by = 6;
   */
  lastActionBy: string;
};

/**
 * Describes the message ga.config_manager.casinokey.CasinoKeyInfo.
 * Use `create(CasinoKeyInfoSchema)` to create a new message.
 */
export const CasinoKeyInfoSchema: GenMessage<CasinoKeyInfo> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 4);

/**
 * @generated from message ga.config_manager.casinokey.VerifyRequest
 */
export type VerifyRequest = Message<"ga.config_manager.casinokey.VerifyRequest"> & {
  /**
   * @generated from field: string casino_id = 1;
   */
  casinoId: string;
};

/**
 * Describes the message ga.config_manager.casinokey.VerifyRequest.
 * Use `create(VerifyRequestSchema)` to create a new message.
 */
export const VerifyRequestSchema: GenMessage<VerifyRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 5);

/**
 * @generated from message ga.config_manager.casinokey.VerifyResponse
 */
export type VerifyResponse = Message<"ga.config_manager.casinokey.VerifyResponse"> & {
};

/**
 * Describes the message ga.config_manager.casinokey.VerifyResponse.
 * Use `create(VerifyResponseSchema)` to create a new message.
 */
export const VerifyResponseSchema: GenMessage<VerifyResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 6);

/**
 * @generated from message ga.config_manager.casinokey.NewCasinoKeyRequest
 */
export type NewCasinoKeyRequest = Message<"ga.config_manager.casinokey.NewCasinoKeyRequest"> & {
  /**
   * @generated from field: string casino_id = 1;
   */
  casinoId: string;

  /**
   * @generated from field: bool create_main_key = 4;
   */
  createMainKey: boolean;

  /**
   * @generated from field: bool create_secondary_key = 5;
   */
  createSecondaryKey: boolean;

  /**
   * @generated from field: string path_vault = 6;
   */
  pathVault: string;
};

/**
 * Describes the message ga.config_manager.casinokey.NewCasinoKeyRequest.
 * Use `create(NewCasinoKeyRequestSchema)` to create a new message.
 */
export const NewCasinoKeyRequestSchema: GenMessage<NewCasinoKeyRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 7);

/**
 * @generated from message ga.config_manager.casinokey.NewCasinoKeyResponse
 */
export type NewCasinoKeyResponse = Message<"ga.config_manager.casinokey.NewCasinoKeyResponse"> & {
  /**
   * @generated from field: string path_vault = 1;
   */
  pathVault: string;

  /**
   * @generated from field: bool main_key_exists = 2;
   */
  mainKeyExists: boolean;

  /**
   * @generated from field: bool secondary_key_exists = 3;
   */
  secondaryKeyExists: boolean;
};

/**
 * Describes the message ga.config_manager.casinokey.NewCasinoKeyResponse.
 * Use `create(NewCasinoKeyResponseSchema)` to create a new message.
 */
export const NewCasinoKeyResponseSchema: GenMessage<NewCasinoKeyResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 8);

/**
 * @generated from message ga.config_manager.casinokey.ListCasinosRequest
 */
export type ListCasinosRequest = Message<"ga.config_manager.casinokey.ListCasinosRequest"> & {
};

/**
 * Describes the message ga.config_manager.casinokey.ListCasinosRequest.
 * Use `create(ListCasinosRequestSchema)` to create a new message.
 */
export const ListCasinosRequestSchema: GenMessage<ListCasinosRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 9);

/**
 * @generated from message ga.config_manager.casinokey.ListCasinosResponse
 */
export type ListCasinosResponse = Message<"ga.config_manager.casinokey.ListCasinosResponse"> & {
  /**
   * @generated from field: repeated ga.config_manager.casinokey.ListCasinosResponse.Casino casinos = 1;
   */
  casinos: ListCasinosResponse_Casino[];
};

/**
 * Describes the message ga.config_manager.casinokey.ListCasinosResponse.
 * Use `create(ListCasinosResponseSchema)` to create a new message.
 */
export const ListCasinosResponseSchema: GenMessage<ListCasinosResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 10);

/**
 * @generated from message ga.config_manager.casinokey.ListCasinosResponse.Casino
 */
export type ListCasinosResponse_Casino = Message<"ga.config_manager.casinokey.ListCasinosResponse.Casino"> & {
  /**
   * @generated from field: string casino_id = 1;
   */
  casinoId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string jurisdiction = 3;
   */
  jurisdiction: string;

  /**
   * @generated from field: string key_obfuscated = 16;
   */
  keyObfuscated: string;

  /**
   * @generated from field: ga.config_manager.casinokey.CasinoKeyState state = 17;
   */
  state: CasinoKeyState;

  /**
   * @generated from field: string last_action_by = 18;
   */
  lastActionBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 19;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 20;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message ga.config_manager.casinokey.ListCasinosResponse.Casino.
 * Use `create(ListCasinosResponse_CasinoSchema)` to create a new message.
 */
export const ListCasinosResponse_CasinoSchema: GenMessage<ListCasinosResponse_Casino> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 10, 0);

/**
 * @generated from enum ga.config_manager.casinokey.CasinoKeyState
 */
export enum CasinoKeyState {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: ACTIVATED = 1;
   */
  ACTIVATED = 1,

  /**
   * @generated from enum value: READY_FOR_APPLYING_NEW_KEY = 2;
   */
  READY_FOR_APPLYING_NEW_KEY = 2,

  /**
   * @generated from enum value: APPLYING_NEW_KEY = 3;
   */
  APPLYING_NEW_KEY = 3,

  /**
   * @generated from enum value: KEY_DEPLOYMENT = 4;
   */
  KEY_DEPLOYMENT = 4,

  /**
   * @generated from enum value: READY_FOR_ROLLING_OUT = 5;
   */
  READY_FOR_ROLLING_OUT = 5,

  /**
   * @generated from enum value: ROLLING_OUT = 6;
   */
  ROLLING_OUT = 6,
}

/**
 * Describes the enum ga.config_manager.casinokey.CasinoKeyState.
 */
export const CasinoKeyStateSchema: GenEnum<CasinoKeyState> = /*@__PURE__*/
  enumDesc(file_ga_config_manager_casinokey_casinokey, 0);

/**
 * @generated from service ga.config_manager.casinokey.CasinoKeyService
 */
export const CasinoKeyService: GenService<{
  /**
   * @generated from rpc ga.config_manager.casinokey.CasinoKeyService.Generate
   */
  generate: {
    methodKind: "unary";
    input: typeof GenerateRequestSchema;
    output: typeof GenerateResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinokey.CasinoKeyService.Rollout
   */
  rollout: {
    methodKind: "unary";
    input: typeof RolloutRequestSchema;
    output: typeof RolloutResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinokey.CasinoKeyService.Verify
   */
  verify: {
    methodKind: "unary";
    input: typeof VerifyRequestSchema;
    output: typeof VerifyResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinokey.CasinoKeyService.NewCasinoKey
   */
  newCasinoKey: {
    methodKind: "unary";
    input: typeof NewCasinoKeyRequestSchema;
    output: typeof NewCasinoKeyResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinokey.CasinoKeyService.ListCasinos
   */
  listCasinos: {
    methodKind: "unary";
    input: typeof ListCasinosRequestSchema;
    output: typeof ListCasinosResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_ga_config_manager_casinokey_casinokey, 0);

